import axios from 'axios'
// import router from '@/router'
import Nprogress from 'nprogress'
import 'nprogress/nprogress.css'
import store from '@/store'
// import {
//   resetTokenAndClearUser,
// } from '@/utils'

const service = axios.create({
  baseURL: 
    process.env.NODE_ENV === 'development'
      ? '/api'
      : '/', // 测试 ： 发布
      // : '/rckdp/api/', // 测试 ： 发布
  timeout: 60000,
})
service.interceptors.request.use(config => {
  Nprogress.start()
  //
  config.headers['Content-Type'] = 'application/json;charset=utf-8'
  config.headers.Authorization = `Bearer `+  store.getters.token; // 设置请求头  每次请求将token绑定到接口请求上
  console.log('config1', config)
  return config
}, (error) => Promise.reject(error))

service.interceptors.response.use(response => {
  console.log("success",response);
  const res = response.data
  //判断code值是10002则表示的是未登录，跳转到登录页面
  if (res && res.code == 10002) {
    // 401表示未登录
    console.error('未登录，跳转到登录页面');
    // this.$message.warning("登录过期请重新登录");
    // 调用跳转到登录页面的函数
    window.location.href = '/login';
    // redirectToLogin();
  }
  Nprogress.done()

  return res
}, (error) => {
  console.log("error");
  // window.location.href = '/login'; // 重定向到登录页面

  // if (error.response && (error.response.status === 401 || error.response.status === 403)) {
  //   // Token过期或无效，需要重新登录
  //   localStorage.removeItem('token'); // 移除过期的token
  //   window.location.href = '/login'; // 重定向到登录页面
  // }

  Nprogress.done()
  return Promise.reject(error)
})
export default service
